/**
 * @description HomeMyHealthPassportHealthRecord State.
 * @exports
 * @interface HomeMyHealthPassportHealthRecordState
 */
export interface HomeMyHealthPassportHealthRecordState {
  error: boolean;
  data: Array<any>;
  loading: boolean;
}

export const homeMyHealthPassportHealthRecordKey =
  'home-myhealthpassport-healthrecord';
export const homeMyHealthPassportHealthRecordState: HomeMyHealthPassportHealthRecordState =
  {
    data: [],
    error: false,
    loading: false
  };
